import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { setMode, toggleMode } from '../../store/actions/app'
import { sidebarShowingSelector } from '../../store/selectors/sidebarSelectors'
import { toggleSidebar } from '../../store/actions/sidebar'
import {
  embedModeSelector,
  modeSelector,
  currentBlockIdSelector
} from '../../store/selectors/selectors'
import { withShortcuts } from '../../containers/Shortcuts'
import { COMMENTER, EDITOR } from '../../constants'
import { accessLevelSelector } from '../../store/selectors/accessSelectors'

export default compose(
  connect(
    state => {
      const accessLevel = accessLevelSelector(state)
      const currentBlock = currentBlockIdSelector(state)
      return {
        sidebarShowing: sidebarShowingSelector(state),
        embed: embedModeSelector(state),
        currentMode: modeSelector(state),
        allowed: {
          view: true,
          discuss: accessLevel >= COMMENTER,
          edit: !currentBlock && accessLevel >= EDITOR
        }
      }
    },
    { toggleSidebar, setMode, toggleMode }
  ),
  // FIXME This kicks you out of a mode if you access changes while you are using the board
  // or if you switch to a board with lower access. This should happen in the store, not in
  // a component - probably a reducer or middleware
  lifecycle({
    componentDidUpdate() {
      if (!this.props.allowed[this.props.currentMode])
        this.props.setMode('view')
    }
  }),
  withShortcuts('MODE_SWITCHER', props => action => {
    switch (action) {
      case 'EDIT_MODE':
        props.toggleMode('edit')
        break
      case 'DISCUSS_MODE':
        props.toggleMode('discuss')
        break
      case 'VIEW_MODE':
        props.setMode('view')
        break
      default:
    }
  })
)
